import {useDispatch, useSelector} from 'react-redux';
import type {TypedUseSelectorHook} from 'react-redux';
import {AppDispatch, RootState} from './store';

// these should be used in place of the normal useSelector and useDispatch
// they will provide inferred types properly.
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;
